<template>
  <header id="header" class="header flex justify-between items-center px-4 py-3">
    <nav class="header__navigation">
      <ul class="menu__list flex flex-wrap gap-4 items-center">
        <li v-for="item in menuItems" :key="item.id" class="menu__item">
          <a
            :href="`#${item.id}`"
            class="menu__link btn flex items-center"
            :class="{ active: activeSection === item.id }"
            @click="setActive(item.id)"
          >
            <!-- Icon FA hanya di mobile -->
            <i
              v-if="item.icon"
              :class="['lg:hidden', item.icon, 'w-5', 'h-5', 'mr-2', 'text-primary']"
            ></i>

            <!-- Label -->
            <span class="menu__caption">{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
   metaInfo: {
    title: 'Farras Naufal Portfolio Website'
  },
  props: ['menuItems'],
  data() {
    return {
      activeSection: 'about',
     menuItems: [
  // { id: 'avatar', label: 'Home', icon: 'fa-solid fa-house' },
  { id: 'about', label: 'About Me', icon: 'fa-solid fa-user' },
  { id: 'tools', label: 'Tools', icon: 'fa-solid fa-wrench' }, // beda dari Skill
  { id: 'skill', label: 'Skills', icon: 'fa-solid fa-lightbulb' },
  { id: 'experience', label: 'Experience', icon: 'fa-solid fa-briefcase' },
  { id: 'education', label: 'Certifications', icon: 'fa-solid fa-certificate' },
  { id: 'contact', label: 'Contact', icon: 'fa-solid fa-envelope' }
]
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    setActive(id) {
      this.activeSection = id;
    },
    handleScroll() {
      let currentSection = '';
      for (const item of this.menuItems) {
        const section = document.getElementById(item.id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = item.id;
          }
        }
      }
      if (currentSection) {
        this.activeSection = currentSection;
      }
    }
  }
};
</script>
